import {
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  NumberInput,
  required,
} from 'react-admin';

const CategoryEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput
        source="name"
        label="Название"
        validate={[required()]}
        fullWidth
      />
      <TextInput
        source="slug"
        label="Слаг"
        validate={[required()]}
        fullWidth
        helperText="Уникальный идентификатор для URL (например: sushi, pizza)"
      />
      <TextInput
        source="description"
        label="Описание"
        multiline
        fullWidth
      />
      <NumberInput
        source="sortOrder"
        label="Порядок сортировки"
        helperText="Чем меньше число, тем выше в списке"
      />
      <BooleanInput
        source="isActive"
        label="Активна"
      />
    </SimpleForm>
  </Edit>
);

export default CategoryEdit;






